const EVENT_NAMES = {
  NFO: "nfo",
  HIGH_GROWTH_FUNDS: "high_growth_funds",
  SAVE_TAX: "save_tax",
  INVEST_FOR_A_GOAL: "invest_for_a_goal",
  PARK_MY_SAVINGS: "park_my_savings",
};

export default EVENT_NAMES;
